$('.translation__toggler').on('click', function() {
    $(this).toggleClass('active');
    $('.translation__content').slideToggle();
});
